"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
function useLoadInitialOptions(onLoadOptions) {
    const [didAttemptInitialOptionsLoad, setDidAttemptInitialOptionsLoad,] = react_1.useState(false);
    react_1.useEffect(() => {
        if (!didAttemptInitialOptionsLoad) {
            onLoadOptions(false);
            setDidAttemptInitialOptionsLoad(true);
        }
    }, [didAttemptInitialOptionsLoad, onLoadOptions]);
}
exports.default = useLoadInitialOptions;
